import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WebhooksComponent } from 'app/webhooks/webhooks.component';
import { WebhookListComponent } from './webhook-list/webhook-list.component';
import { RouterModule } from '@angular/router';
import { webhookRoutes } from 'app/webhooks/webhooks.routes';
import { LayoutModule } from 'app/shared/layout/layout.module';
import { TranslateModule } from '@ngx-translate/core';
import { EffectsModule } from '@ngrx/effects';
import { WebhooksEffects } from 'app/webhooks/webhooks.effects';
import { SharedModule } from 'app/shared/shared.module';
import { WebhookListData } from 'app/webhooks/webhook-list/webhook-list.data';
import { StoreModule } from '@ngrx/store';
import { webhooksReducer } from 'app/webhooks/webhooks.reducer';
import { UiSwitchModule } from 'ngx-ui-switch';
import { WebhookFormComponent } from './webhook-form/webhook-form.component';
import { WebhookTypesResolver } from 'app/webhooks/resolvers/WebhookTypesResolver';
import { SingleWebhookResolver } from 'app/webhooks/resolvers/SingleWebhookResolver';
import { WebhookTypesDropdownComponent } from './webhook-list/webhook-types-dropdown/webhook-types-dropdown.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forRoot(webhookRoutes),
    EffectsModule.forFeature([WebhooksEffects]),
    StoreModule.forFeature('webhooks', webhooksReducer),
    LayoutModule,
    TranslateModule,
    SharedModule,
    UiSwitchModule
  ],
  declarations: [WebhooksComponent, WebhookListComponent, WebhookFormComponent, WebhookTypesDropdownComponent],
  providers: [WebhookListData, WebhookTypesResolver, SingleWebhookResolver]
})
export class WebhooksModule {}
